import { render, staticRenderFns } from "./GuardsEdit.vue?vue&type=template&id=46f3ed91&"
import script from "./GuardsEdit.vue?vue&type=script&lang=js&"
export * from "./GuardsEdit.vue?vue&type=script&lang=js&"
import style0 from "./GuardsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports